import React from 'react';
import Notice from '../containers/Notice/Notice';

export const NoticePage = () => <Notice />;

